<span margin-right base-height>
  <rt-heading>{{ 'app.stages.candidate_anonymization.info-bar.heading' | translate }}</rt-heading>
  •
  <span>{{ 'app.stages.candidate_anonymization.info-bar.subheading' | translate }}</span>
  &nbsp;
  @if (anonymousStage()) {
    <rt-anonymous-learn-more-trigger
      [anonymousStage]="anonymousStage()!"
    ></rt-anonymous-learn-more-trigger>
  }
</span>
<ng-content select="[rightSlot]"></ng-content>
